export default "__VITE_ASSET__CqHaI7cB__"